import { FC, PropsWithChildren } from "react";
import { colSpanClassName, gapClassName, growClassName } from "./commonClassNames";
import { ColSpanProp, GapProp, GrowProp } from "./commonProps";

type GridCols = 1 | 2 | 3 | 4 | "auto-250px-1fr" | "grid-cols-2-50p" | "grid-cols-3";

type Props = ColSpanProp &
  GapProp &
  GrowProp & {
    cols?: GridCols;
    center?: boolean;
    className?: string;
  };

function gridColsClassName(cols?: GridCols) {
  switch (cols) {
    case 1:
      return "grid-cols-1";
    case 2:
      return "grid-cols-1 md:grid-cols-2";
    case 3:
      return "grid-cols-1 md:grid-cols-3";
    case 4:
      return "grid-cols-1 md:grid-cols-4";
    // This is a custom class, see src/styles/tailwind.css
    case "auto-250px-1fr":
      return "grid-cols-auto-250px-1fr";
    case "grid-cols-2-50p":
      return "grid-cols-2";
    case "grid-cols-3":
      return "grid-cols-3";
    default:
      return "";
  }
}

/** @deprecated use div with tailwind styles directly */
export const Grid: FC<PropsWithChildren<Props>> = ({ children, center, cols, colSpan, gap, grow, className }) => {
  const combinedClassName = [
    "grid",
    center ? "place-content-center" : "",
    colSpanClassName({ colSpan }),
    growClassName({ grow }),
    gapClassName({ gap }),
    gridColsClassName(cols),
    className ?? "",
  ].join(" ");

  return <div className={combinedClassName}>{children}</div>;
};
